<template>
  <v-card outlined class="rounded-lg">
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-icon color="primary" class="mr-2">mdi-medal-outline</v-icon>Recognition
      <v-spacer />
      <v-btn small color="primary" class="text-none" @click="openFor(null)"><v-icon small left>mdi-plus</v-icon>Give recognition</v-btn>
    </v-card-title>
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate />
      <v-alert v-else-if="error" type="error" dense outlined>{{ error }}
        <v-btn small text @click="load">Retry</v-btn>
      </v-alert>
      <div v-else-if="data">
        <div class="caption font-weight-bold mb-1">Most recognised</div>
        <div v-if="!top.length" class="caption grey--text mb-2">No recognition in this period.</div>
        <div v-for="t in top" :key="t.user_id" class="body-2 d-flex">{{ t.name }}<v-spacer /><v-chip x-small>{{ t.count }}</v-chip></div>

        <div class="caption font-weight-bold mt-3 mb-1">Top givers</div>
        <div v-if="!(data.top_givers || []).length" class="caption grey--text mb-2">No recognition given in this period.</div>
        <div v-for="t in (data.top_givers || [])" :key="'g' + t.user_id" class="body-2 d-flex">{{ t.name }}<v-spacer /><v-chip x-small>{{ t.count }}</v-chip></div>

        <div class="caption font-weight-bold mt-3 mb-1">Not yet recognised ({{ none.length }})</div>
        <div class="d-flex flex-wrap" style="gap:4px">
          <v-chip v-for="n in none.slice(0, 12)" :key="n.user_id" x-small outlined @click="openFor(n.user_id)">{{ n.name }}</v-chip>
          <span v-if="none.length > 12" class="caption grey--text">+{{ none.length - 12 }} more</span>
        </div>

        <div class="caption font-weight-bold mt-3 mb-1">Recent</div>
        <div v-if="!recent.length" class="caption grey--text">Nothing yet.</div>
        <div v-for="r in recent" :key="r.id" class="body-2 mb-2">
          <v-chip x-small class="mr-1">{{ r.category }}</v-chip><strong>{{ r.to }}</strong>: {{ r.message }}
          <span class="caption grey--text"> — {{ r.from }}</span>
        </div>
      </div>
    </v-card-text>

    <v-dialog v-model="dialog" max-width="440">
      <v-card>
        <v-card-title class="subtitle-1">Give recognition</v-card-title>
        <v-card-text>
          <v-autocomplete v-model="draft.recipient_id" :items="people" item-text="name" item-value="id" label="Employee" dense outlined />
          <v-select v-model="draft.category" :items="categories" label="Category" dense outlined />
          <v-textarea v-model="draft.message" label="Message" rows="3" counter="2000" dense outlined />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" :disabled="!draft.recipient_id || !draft.message.trim()" @click="save">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { getRecognition, giveRecognition } from '@/services/adminGrowthService'

const blankDraft = id => ({ recipient_id: id, category: 'Delivery', message: '' })

export default {
  name: 'AdminRecognitionPanel',
  inject: ['users'],
  props: { range: { type: Object, required: true } },
  data() {
    return {
      data: null, loading: false, error: null,
      dialog: false, saving: false,
      draft: blankDraft(null),
      categories: ['Leadership', 'Teamwork', 'Innovation', 'Mentoring', 'Delivery', 'Communication'],
    }
  },
  computed: {
    people() { return (this.users() || []).filter(u => u && u.name && !u.is_bot) },
    top() { return (this.data && this.data.top) || [] },
    none() { return (this.data && this.data.none) || [] },
    recent() { return (this.data && this.data.recent) || [] },
  },
  watch: {
    range: { handler: 'load', deep: true },
  },
  created() {
    this.reqId = 0 // non-reactive request counter (guards out-of-order responses)
  },
  mounted() { this.load() },
  methods: {
    async load() {
      const { from, to } = this.range
      if (!from || !to || (from !== 'all' && from > to)) return
      const id = ++this.reqId
      this.loading = true; this.error = null
      try {
        const data = await getRecognition(from, to)
        if (id !== this.reqId) return
        this.data = data
      } catch (e) {
        if (id !== this.reqId) return
        this.error = e.message
      } finally {
        if (id === this.reqId) this.loading = false
      }
    },
    openFor(id) {
      this.draft = blankDraft(id)
      this.dialog = true
    },
    async save() {
      this.saving = true
      try {
        await giveRecognition({ ...this.draft, message: this.draft.message.trim() })
        this.$toast.success('Recognition sent')
        this.dialog = false
        this.draft = blankDraft(null)
        this.$emit('given')
        await this.load()
      } catch (e) {
        this.$toast.error(e.message)
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
